import Flickity from 'flickity';
import Alpine from 'alpinejs';

document.addEventListener("alpine:init", () => {

	Alpine.data('carousel', (options = {}) => ({
		elem: '.x-slider',
		slider: null,
		options: {
			pageDots: true,
			wrapAround: true,
			prevNextButtons: false,
			groupCells: false,
			contain: false,
			cellAlign: 'left'
		},
		init(){
			const opts = Object.assign({}, this.options, options);
			this.slider = new Flickity( this.$el.querySelector( this.elem ), opts);
			
			this.setPagerClass();
		},

		setPagerClass(){
			const slides = this.slider.slides.length;
			const el = this.$el.querySelector( this.elem );

			const slidesClassRegex = /^slides-\d+$/;

			el.classList.forEach(className => {
				if (slidesClassRegex.test(className)) {
					el.classList.remove(className);
				}
			});

			el.classList.add( 'slides-' + slides );
		},

		doResize(){
			this.$el.querySelector( this.elem ).querySelector('.flickity-viewport').style.height = null;
			this.slider.resize();
			this.setPagerClass();
		},
		nextSlide(){
			this.slider.next();
		},
		prevSlide(){
			this.slider.previous();
		}
	}));

});